import { render } from "./DocumentClassDeleteReasonsSubView.vue?vue&type=template&id=3fe20ada&scoped=true&ts=true"
import script from "./DocumentClassDeleteReasonsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassDeleteReasonsSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassDeleteReasonsSubView.vue?vue&type=style&index=0&id=3fe20ada&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe20ada"]])

export default __exports__